module.exports = __webpack_public_path__ + "img/vuelo5.0bba48ce.jpg";